import { $, $$ } from '../../helpers/shortcuts';
import { render } from 'preact';
import { NavigationWrapper } from './NavigationWrapper.component';
import { html } from '../../helpers/preact-html';

function initializeNavigation() {
  const navigationPlaceholderComponents = $$('navigation-placeholder');
  navigationPlaceholderComponents.forEach((node) => node.remove());

  const navigationNode = $('.navigation');
  if (!navigationNode) return;

  const navTreeUrl = navigationNode.getAttribute('data-navtree-url');
  const logo = {
    src: navigationNode.getAttribute('data-logo-src'),
    alt: navigationNode.getAttribute('data-logo-alt'),
    width: navigationNode.getAttribute('data-logo-width'),
    height: navigationNode.getAttribute('data-logo-height'),
  };

  if (!navTreeUrl || navTreeUrl.length === 0) {
    throw new Error(
      `Navigation tree URL at the navigation node ('.navigation') is empty or does not exist. Please add the URL using the 'data-navtree-url' property.`,
    );
  }

  fetch(navTreeUrl)
    .then((res) => res.json())
    .then((navTree) =>
      render(
        html`<${NavigationWrapper} navTree=${navTree} logo=${logo} />`,
        navigationNode,
      ),
    );
}

export { initializeNavigation, html };
